import { ArrowLeftRight } from "lucide-react";
import { PageHero, Container, SplitSection, CTASection, PrimaryButton, SectionHead } from "@/components/common/Section";
import { Reveal } from "@/lib/anim";
import { PLATFORMS } from "@/lib/content";
import DashboardMock from "@/components/visuals/DashboardMock";
import WalletMock from "@/components/visuals/WalletMock";
import EmulationFlow from "@/components/visuals/EmulationFlow";

const VISUALS = {
  zenpay: <DashboardMock />,
  wallet: <WalletMock />,
  emulation: <EmulationFlow />,
};

export default function Platforms() {
  return (
    <>
      <PageHero
        eyebrow="Our Platforms"
        title="Modular platforms for the financial ecosystem."
        copy="Configurable, multi-tenant payment infrastructure, built, operated and evolved by iJeeva. Each platform is production-proven and designed to integrate with the systems you already run."
        testid="platforms-page-title"
      />
      <section className="py-20 lg:py-24">
        <Container className="space-y-24">
          {PLATFORMS.map((p, i) => (
            <SplitSection
              key={p.id}
              eyebrow={p.subtitle}
              title={p.name}
              copy={p.desc}
              points={p.capabilities}
              visual={VISUALS[p.id]}
              reverse={i % 2 === 1}
              cta={
                <PrimaryButton to={p.to} testid={`platforms-${p.id}-cta`}>
                  {p.cta}
                </PrimaryButton>
              }
            />
          ))}
        </Container>
      </section>
      <section className="border-y border-[#E2E8F0] bg-white">
        <Container className="py-16">
          <Reveal className="flex flex-col items-start gap-6 rounded-2xl border border-[#E2E8F0] bg-[#F8FAFC] p-8 sm:flex-row sm:items-center lg:p-10">
            <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-[10px] bg-[#1D305B] text-[#5EEAD4]">
              <ArrowLeftRight className="h-5 w-5" />
            </span>
            <div>
              <h2 className="text-xl font-semibold text-[#1D305B]">P2P payment capabilities</h2>
              <p className="mt-2 max-w-2xl text-[15px] leading-relaxed text-[#64748B]">
                Peer-to-peer transfer infrastructure is built into the iJeeva wallet stack: ledger-backed, multi-currency
                and ready to embed into consumer and business products.
              </p>
            </div>
          </Reveal>
        </Container>
      </section>
      <CTASection
        title="Not sure which platform fits?"
        copy="Tell us what you're building. We'll map your requirements to the right infrastructure."
      />
    </>
  );
}
